import { Charts } from '@services/API/trusts/lender/charts.service';
import { FacilitiesService } from '@services/API/trusts/lender/facilities.service';
import { Overview } from '@services/API/trusts/lender/overview/overview.service';
import { FiltersService } from '@services/API/trusts/operations/filters/filters.service';

export const LenderAPI = {
  Overview,
  Charts,
  FacilitiesService,
  FiltersService,
};
